import { render, staticRenderFns } from "./BaseRiskLevel.vue?vue&type=template&id=1c4ec428&"
import script from "./BaseRiskLevel.vue?vue&type=script&lang=ts&"
export * from "./BaseRiskLevel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports